module.exports = __webpack_public_path__ + "img/wysylka.b931d247.svg";